export default __webpack_public_path__ + "static/media/rightTriangle.8423c132.svg";